import { render, staticRenderFns } from "./FirstRun.vue?vue&type=template&id=d6d27f12&scoped=true&"
import script from "./FirstRun.vue?vue&type=script&lang=ts&"
export * from "./FirstRun.vue?vue&type=script&lang=ts&"
import style0 from "./FirstRun.vue?vue&type=style&index=0&id=d6d27f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d27f12",
  null
  
)

export default component.exports